import avatarPro from "assets/img/Share-Safari/dpinterested.png";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
import UserComments from "./UserComments";
import { obfuscateSensitiveNumbers } from "Data/regx";
const { useSharedSafariContext } = require("provider/ShareSafariProvider");

const Discussion = () => {
  const { safariViewData } = useSharedSafariContext();

  return (
    <div className="formbg mb-3">
      <button
        className="discussionTabs"
        style={{
          backgroundColor: "var(--background-primary)",
          cursor: "default",
        }}
        value=""
      >
        Discussion
      </button>
      <div className="comments_safari bg-white">
        <div className="top_replysafari px-3">
          <div className="comments-persons">
            <div className="postcomment d-flex gap-2">
              <div className="avatar">
                {safariViewData?.is_safari_operator ?
                  <Link
                    to={`/operator/${safariViewData.organized_slug}/profile`}
                    data-pjax="0"
                  >
                    <img
                      src={
                        safariViewData?.organized_by_image?.trim()
                          ? safariViewData.organized_by_image
                          : avatarPro
                      }
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = avatarPro;
                      }}
                      className=""
                      alt="banner"
                    />
                  </Link>
                  :
                  <Link
                    to={`/profile/user/${safariViewData?.organized_slug}`}
                    data-pjax="0"
                  >
                    <img
                      src={
                        safariViewData?.organized_by_image?.trim()
                          ? safariViewData.organized_by_image
                          : avatarPro
                      }
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = avatarPro;
                      }}
                      className="rounded-circle"
                      alt="banner"
                    />
                  </Link>
                }
              </div>
              <div className="text_com">
                {safariViewData?.is_safari_operator ?
                  <Link
                    to={`/operator/${safariViewData.organized_slug}/profile`}
                  >
                    <h6 className="nameavatr">
                      {safariViewData?.organized_by_name}
                    </h6>
                  </Link>
                  :
                  <Link
                    to={`/profile/user/${safariViewData?.organized_slug}`}
                  >
                    <h6 className="nameavatr">
                      {safariViewData?.organized_by_name}
                    </h6>
                  </Link>
                }

                <div className="profile-description">
                  <div className="text show-more-height">
                    {safariViewData?.safari_plan &&
                      parse(obfuscateSensitiveNumbers(safariViewData?.safari_plan))}
                  </div>
                  <div className="show-more">See More</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <UserComments />
      </div>
    </div>
  )
}

export default Discussion;